import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Thumbnail, Table, Button } from 'react-bootstrap';
import axios from 'axios';
import { setBreadCrumbs } from '../actions/breadcrumbs.js';
import { getWorflowStepList, getWorkflowImage, getWorflowStepResultById } from '../api/ispyb.js';
import Sidebar from 'react-sidebar';
import TemplateJsonPanel from '../components/TemplateJsonPanel.js';


const mql = window.matchMedia(`(min-width: 800px)`);

class MXWorflowContainer extends Component {
  constructor(props) {
      super(props);       
      this.state = {   
        fetching : true,
        workflows : [],
        active : {
          items : [],
          title : null,
          type : 'null'
        },
        sidebarOpen: true,
        sidebarDocked : mql.matches         
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.onButtonClicked = this.onButtonClicked.bind(this);
  }

 
componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false });
  }


  onButtonClicked() {
    this.onSetSidebarOpen(!this.state.sidebarOpen);
  }
  /**
   * This method will retrieve the experiments for a given session
   * A experiment might be calibration, sample changer or HPLC
   */
  componentDidMount(){ 
   
    var _this = this;                 
    axios({
        method: 'GET',
        url: getWorflowStepList(_this.props.user, _this.props.proposal, _this.props.workflowStepIds),            
    })
    .then(function (response) {    
                
        _this.setState({
            workflows : response.data,
            fetching : false,
            fetched : true
        });        
    })
    .catch(function (error) {            
        _this.setState({
            error : error,
            fetching : false,
            fetched : false
        });
    });
  }

  openWorkflowStep(workflowStepId){
        var _this = this;    
         this.setState({                
                fetching : true
         });            
        axios({
            method: 'GET',
            url: getWorflowStepResultById(_this.props.user, _this.props.proposal, workflowStepId),            
        })
        .then(function (response) {                           
            _this.setState({
                active : response.data,
                fetching : false,
                fetched : true
            });        
        })
        .catch(function (error) {            
            _this.setState({
                error : error,
                fetching : false,
                fetched : false
            });
        });  
  }
  getSideBarMenu(){   
    
    return <Table style={{margin:'5px 5px 70p 5px'}}>{this.state.workflows.map((value, index) => {                    
                  return <tr>
                            <td>                                
                                 <Thumbnail style={{width:'150px'}}src={getWorkflowImage(this.props.user, this.props.proposal, value.workflowStepId)}>                                           
                                            <h4>{value.workflowStepType}</h4>
                                            <p>{value.status}</p>
                                            <Button bsStyle="primary" bsSize="xsmall" onClick={() => this.openWorkflowStep(value.workflowStepId)} >Open</Button>
                                    </Thumbnail>
                            </td>
                  </tr>
    })}
    </Table>

  }

 
  render() {               
    if ((!this.props.user) || (!this.props.user.token)) {         
      return null;
    }
    
    return  <Sidebar 
                styles = {{                               
                     root: {
                        zIndex: 1,
                        position: "fixed",
                        top: 90                     
                      }
                  }
                }
                sidebar   = {this.getSideBarMenu()}
                open      = {this.state.sidebarOpen}
                docked    = {this.state.sidebarDocked}
                onSetOpen = {this.onSetSidebarOpen}
                shadow    = {true}                
                >
               <div style={{margin:'80px 5px 100px 20px'}}>                       
                         <TemplateJsonPanel items={this.state.active.items} title={this.state.active.title} type={this.state.active.type}></TemplateJsonPanel>
                </div>
              </Sidebar>  
      
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {  
    setBreadCrumbs: (breadCrumbs) => dispatch(setBreadCrumbs(breadCrumbs))    
  };
}

MXWorflowContainer.propTypes = {
  sessionId: PropTypes.string,
  workflowStepIds: PropTypes.string,
  workflowId: PropTypes.string,
  proposal: PropTypes.string
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MXWorflowContainer);










// WEBPACK FOOTER //
// ./src/containers/MXWorflowContainer.js